import { rgb } from 'pdf-lib';
import { DocumentElement } from './document-element.model';

export const PermissionConfiguration: DocumentElement = {
  generationDate: {
    x: 93,
    y: 592.25,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold-italic',
    height: 0,
    width: 0,
    adjustBy: 'height',
  },
  name: {
    x: 150,
    y: 488,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  registerNumber: {
    x: 0,
    y: 459.6,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  permissionDate: {
    x: 150,
    y: 431,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  article: {
    x: 150,
    y: 402.3,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
  validFor: {
    x: 150,
    y: 374,
    rotate: 0,
    size: 11,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 180, end: 536 },
  },
};
